export default {
  title: 'Código promocional',
  fields: {
    preset: {
      label: 'Plantilla',
    },
    presets: {
      master: 'Maestro',
      campaign: 'Campaña',
      one_time: 'Un solo uso',
    },
    code: {
      label: 'Código',
      placeholder: 'Introduce el código',
    },
    discount_type: {
      label: 'Tipo de descuento',
    },
    quantity: {
      label: 'Cantidad',
      placeholder: 'Infinito',
    },
    expires_at: {
      label: 'Fecha de vencimiento',
      placeholder: 'Introduce una fecha o deja en blanco',
    },
    franchise: {
      label: 'Código promocional maestro para el restaurante o para toda la marca',
    },
    discount: {
      label: 'Descuento',
    },
    usage_threshold: {
      label: 'Umbral de uso',
    },
  },
  messages: {
    master_warning: 'Crear un nuevo código promo «maestro» hará que el actual expire',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    promo_code_got_created: 'Código promocional creado',
    promo_code_got_updated: 'Código promocional actualizado',
  },
};
